import React from 'react';
// @ts-ignore
import styles from './EPrescriptionMedicamentsListItem.module.scss';
import { PrescriptionType } from '../../../Enums/PrescriptionType.enum';
import EPrescriptionMedicamentsListItemHVLP from './EPrescriptionMedicamentsListItemHVLP';
import EPrescriptionMedicamentsListItemIPLP from './EPrescriptionMedicamentsListItemIPLP';
import { EPrescriptionMedicament } from './EPrescriptionMedicamentsWrapper';
import { EPrescriptionHVLPMedicament } from './EPrescriptionMedicamentsHVLPForm';
import { EPrescriptionIPLPMedicament } from './EPrescriptionMedicamentsIPLPForm';

interface EPrescriptionMedicamentsListItemProps {
	item: EPrescriptionMedicament;
	onRemove: (item: EPrescriptionMedicament) => void;
	onEdit: (item: EPrescriptionMedicament) => void;
}

const EPrescriptionMedicamentsListItem: React.FC<
	EPrescriptionMedicamentsListItemProps
> = ({ item, onRemove, onEdit }) => {
	if (item.formType === PrescriptionType.HVLP) {
		return (
			<EPrescriptionMedicamentsListItemHVLP
				item={item as EPrescriptionHVLPMedicament}
				onRemove={onRemove}
				onEdit={onEdit}
			/>
		);
	}

	if (item.formType === PrescriptionType.IPLP) {
		return (
			<EPrescriptionMedicamentsListItemIPLP
				item={item as EPrescriptionIPLPMedicament}
				onRemove={onRemove}
				onEdit={onEdit}
			/>
		);
	}

	return null;
};

export default EPrescriptionMedicamentsListItem;
